module.exports = __webpack_public_path__ + "img/bulletin-board.707595aa.svg";